import { all, takeLatest, put, call, select } from "redux-saga/effects";
import { toast } from 'react-hot-toast';
import enterpriseStripeBillingAddEditSlice, { createMyEnterpriseStripeCustomer, loadMyEnterpriseStripeBilling } from "./slice";
import { IConfiguration } from "../../../shared/types";
import { SimplyTestApi } from "../../../api/simplytest";
import { selectConfig } from "../../../shared/redux/slice";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { AxiosResponse } from "axios";
import { Enterprise } from "../../../api/types";

export abstract class EnterpriseStripeBillingAddEditSagas {
    public static* run() {
        try {
            yield all([
                takeLatest(loadMyEnterpriseStripeBilling, EnterpriseStripeBillingAddEditSagas.loadMyEnterpriseStripeBilling),
                takeLatest(createMyEnterpriseStripeCustomer, EnterpriseStripeBillingAddEditSagas.createMyEnterpriseStripeCustomer),
            ]);
        }
        catch(e: any){
            toast.error('Unable to register EnterpriseStripeBillingAddEdit module.');
            console.log(`[EnterpriseStripeBillingAddEditSagas:run] the following exception has occurred`, e);
        }
    }

    public static* loadMyEnterpriseStripeBilling(){
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const loadResponse: AxiosResponse<Enterprise> = yield call(
                {
                    context: client,
                    fn: client.getMyEnterpriseStripeBilling,
                },
            );

            if(loadResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(loadResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(enterpriseStripeBillingAddEditSlice.actions.setEnterprise(loadResponse.data));
        }
        catch(e: any){
            toast.error('Unable to load your Enterprise\'s Stripe billing data.');
            console.log(`[EnterpriseStripeBillingAddEditSagas:loadMyEnterpriseStripeBilling] the following exception has occurred`, e);
        }
    }

    public static* createMyEnterpriseStripeCustomer(action: ReturnType<typeof createMyEnterpriseStripeCustomer>){
        const { payload: { name, postalcode }} = action;
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const createCustomerResponse: AxiosResponse<string> = yield call(
                {
                    context: client,
                    fn: client.createMyEnterpriseStripeCustomer,
                },
                name,
                postalcode,
            );

            if(createCustomerResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(createCustomerResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(loadMyEnterpriseStripeBilling());
        }
        catch(e: any){
            toast.error('Unable to set up Stripe billing for your Enterprise.');
            console.log(`[EnterpriseStripeBillingAddEditSagas:createMyEnterpriseStripeCustomer] the following exception has occurred`, e);
        }
    }
}
